import angular from "angular";
import permission from "../permission";
import core from "../../core/core.module";

angular
    .module('accessControlCrud.permissionForm', [permission, core])
    .component('permissionForm', {
        controller: ['Permission', 'notifier', controller],
        template: require('./permission-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(Permission, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.moduleId = $ctrl.resolve.moduleId;
        $ctrl.id = null;
        $ctrl.key = null;
        $ctrl.name = null;
        if ($ctrl.resolve.permission) {
            $ctrl.id = $ctrl.resolve.permission.id;
            $ctrl.key = $ctrl.resolve.permission.key;
            $ctrl.name = $ctrl.resolve.permission.name;
        }
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            moduleId: $ctrl.moduleId,
            key: $ctrl.key,
            name: $ctrl.name
        };

        let defer = $ctrl.id ? Permission.update($ctrl.id, params) : Permission.store(params);

        defer.then(
            function (response) {
                $ctrl.loading = false;
                if (!$ctrl.id) {
                    $ctrl.id = response.data.id;
                    params.id = response.data.id;
                }
                closeModal(params);
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );

    };

    function closeModal(permission) {
        $ctrl.close({
            $value: {
                permission: permission
            }
        });
    }

    $ctrl.deletePermission = function () {
        if (!confirm('Вы действительно хотите удалить операцию?')) {
            return;
        }
        $ctrl.deleteLoading = true;
        Permission.delete($ctrl.id).then(
            function () {
                notifier.successNotify('Операция успешно удалена', 3000);
                closeModal();
            },
            function (error) {
                notifier.errorResponseNotify(error);
            }
        );
    };
}

export default "accessControlCrud.permissionForm";


// WEBPACK FOOTER //
// ./resources/assets/modules/access-control-crud/permission-form/permission-form.js